export default __webpack_public_path__ + "static/media/cloud-download.48919d79.png";